export default async function GetUsers(clientId) {
    let url = window.UserService+  `/api/Users/GetUsers?clientId=${clientId}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*",
        "Authorization":window.token
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
        // body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}